"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountDetails = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const blueprint_1 = require("@groma-dev/blueprint");
const Avatar_1 = require("../Avatar/Avatar");
const Utils_1 = require("../../utils/Utils");
const AccountDetails_module_scss_1 = __importDefault(require("./AccountDetails.module.scss"));
/**
 * The Account Details component provides user details when authenticated.
 * @param props
 * @constructor
 */
const AccountDetails = (props) => {
    const { testId, className, children, user } = props, remainingProps = __rest(props, ["testId", "className", "children", "user"]);
    const dti = (0, blueprint_1.getTestIdAttribute)(testId);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({}, remainingProps, { className: (0, blueprint_1.classNames)('Header-accountDetails-local', className, AccountDetails_module_scss_1.default.container) }, dti, { children: [(0, jsx_runtime_1.jsx)(Avatar_1.Avatar, { testId: "avatar", children: (0, Utils_1.parseUserInitials)(user) }), (0, jsx_runtime_1.jsxs)("div", { className: (0, blueprint_1.classNames)('Header-account-local', AccountDetails_module_scss_1.default.account), children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ className: (0, blueprint_1.classNames)('Header-accountName-local', AccountDetails_module_scss_1.default.name) }, (0, blueprint_1.getTestIdAttribute)('accountName'), { children: `${user.first_name} ${user.last_name}` })), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: (0, blueprint_1.classNames)('Header-accountEmail-local', AccountDetails_module_scss_1.default.email) }, (0, blueprint_1.getTestIdAttribute)('accountEmail'), { children: user.email }))] })] })));
};
exports.AccountDetails = AccountDetails;
